import {
    Box,
    Flex,
    Text,
    useColorMode,
    BoxProps,
} from "@chakra-ui/react";
import {Link} from "react-router-dom";

export type NavItemProps = {
    icon: string;
    active?: boolean;
    count?: number;
    href?: string;
    name: string;
    onClick?: () => void;
    onClose?: VoidFunction
};

export default function NavItem(props: NavItemProps) {
    const {colorMode} = useColorMode();
    const activeProps: BoxProps = {
        border: "1px #017172 solid",
        bg: colorMode === "light" ? "#F5F7F9" : "transparent",
    };
    return <Link to={`${props.href}`}>
        <Box
            bg={colorMode === "light" ? "#F5F7F9" : "transparent"}
            h={"50px"}
            w={{ base: "100%", md: "262px" }}
            borderRadius={"8px"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
            px="8px"
            py="13px"
            cursor={"pointer"}
            {...(props.active && activeProps)}
            onClick={props.onClose}
        >
            <Flex alignItems={"center"} color="primary.500">
                <svg width="24" height="24" aria-hidden="true" style={{flex: "0 0 auto", color: "#017172"}}>
                    <use xlinkHref={`#${props.icon}`} />
                </svg>

                <Text
                    fontSize="16px"
                    fontWeight={500}
                    w={"100%"}
                    ml={5}
                    color={
                        props.active
                            ? "primary.900"
                            : colorMode === "light"
                                ? "dark.500"
                                : "#fff"
                    }
                >
                    {props.name}
                </Text>
            </Flex>
        </Box>
    </Link>;
}
